module.exports = __webpack_public_path__ + "f0f69a7b1c4339018e8cd2dfee4c4a02.png";